import { UserEntity } from 'sonata-static-storage/lib/entities';
import { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';

import { getObjectByKeys } from '../../helpers';
import { useGlobalStore } from '../index';

import type { GlobalStore } from '../index';

// SETTERS
export const setUser = useGlobalStore.getState().setUser;
export const reloadUser = useGlobalStore.getState().reloadUser;

// GETTERS
export const getUser = (store: GlobalStore): UserEntity => {
  const { user } = store;
  return user as UserEntity;
};

export const getUserByKeys = ({ user }: GlobalStore, keys: (keyof UserInterface)[]) => {
  if (Object.keys(user).length > 0) {
    return getObjectByKeys(user.toJSON(), keys);
  }
  return {};
};
